// client/src/components/icons/Megaphone.js
//
// Functional icon — a coach-only affordance on AnnouncementsHome's
// PageTitle garnish that opens /announcements/new. Not a mischief
// primitive, but sits next to them visually via a small felt-tilt
// applied by the callsite (not baked in) so the icon stays reusable
// if we ever surface it somewhere untilted (a drawer entry, say).
//
// Inherits color from currentColor, so callers set the color via
// text-* Tailwind classes (or inline style). Default size 24 matches
// a body-line-height standard; caller can override via width/height.

export function Megaphone({
  size = 24,
  className = '',
  ...rest
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...rest}
    >
      {/* Cone — the horn */}
      <path d="M3 11v2a1 1 0 0 0 1 1h2l7 4V6L6 10H4a1 1 0 0 0-1 1z" />
      {/* Handle nub at the back */}
      <path d="M13 6v12" />
      {/* Sound waves — three short arcs radiating from the horn's mouth */}
      <path d="M17 9c1 1 1 5 0 6" />
      <path d="M19.5 7.5c2 2 2 7 0 9" />
    </svg>
  );
}